module.exports = "button.btn-login{width:150px}\n"